import React, { useState, useContext } from 'react';
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";

import { observer } from 'mobx-react';
import { useStore } from '../../sdo.js'
import {useNavigate} from "react-router-dom";
import sso from "../../sso";

function Gym_Menu(props) {
    var navigate = useNavigate();
    var row = {};
    //if(props.store.fkn) row = props.store.fkn;
    let [state, setState] = useState({row: row, mnu: "", htitle: "", ma: []});
    let ctx = useStore();

    var lock = "lock";
    var moa = {};
    moa["f00"] = { fid: "f00", name: "Hem", url: "/gym", icon: "home", fa: "fa fa-home flex", ma: [] };
    moa["f01"] = { fid: "f01", name: "Beläggning", url: "/gym/bel", icon: "key", fa: "fa fa-key flex", ma: [] };
    moa["f02"] = { fid: "f02", name: "Medlemmar", url: "/gym/mbr", icon: "play", fa: "fa fa-play flex", ma: [] };
    moa["f03"] = { fid: "f03", name: "Drift", url: "/gym/run", icon: "desktop", fa: "fa fa-desktop flex", ma: [] };
    moa["f04"] = { fid: "f04", name: "Manager", url: "/gym/man", icon: "chart-bar", fa: "fa fa-chart-bar flex", ma: [] };
    moa["f05"] = { fid: "f05", name: "Personal", url: "/gym/prs", icon: "chart-bar", fa: "fa fa-chart-bar flex", ma: [] };
    moa["f07"] = { fid: "f07", name: "Backoffice", url: "/gym/bo", icon: "cogs", fa: "fa fa-cogs flex", ma: [] };

    moa["f01"].ma.push( { fid: "f01", name: "Totalstatus", url: "/gym/stat/total", fa: "fa fa-bars" } );
    moa["f01"].ma.push( { fid: "f01", name: "Timstatus", url: "/gym/stat/hh", fa: "fa fa-bars" } );
    moa["f01"].ma.push( { fid: "f01", name: "Veckostatus", url: "/gym/stat/week", fa: "fa fa-bars" } );
    moa["f01"].ma.push( { fid: "f01", name: "Tidperiod", url: "/gym/stat/tp", fa: "fa fa-bars" } );
    moa["f01"].ma.push( { fid: "f01", name: "Omsättning", url: "/gym/stat/oms", fa: "fa fa-bars" } );

    moa["f02"].ma.push( { fid: "f02", name: "Register", url: "/gym/mbr/mreg", fa: "fa fa-bars" } );
    moa["f02"].ma.push( { fid: "f02", name: "Medlemskap", url: "/gym/mbr/mship", fa: "fa fa-bars" } );
    moa["f02"].ma.push( { fid: "f02", name: "Ekonomi", url: "/gym/mbr/eko", fa: "fa fa-bars" } );
    moa["f02"].ma.push( { fid: "f02", name: "Logg", url: "/gym/mbr/logg", fa: "fa fa-bars" } );
    moa["f02"].ma.push( { fid: "f02", name: "Statistik", url: "/gym/mbr/stat", fa: "fa fa-bars" } );

    moa["f03"].ma.push( { fid: "f03", name: "Struktur", url: "/gym/prds/str", fa: "fa fa-bars" } );
    moa["f03"].ma.push( { fid: "f03", name: "Produkter", url: "/gym/prds/plus", fa: "fa fa-bars" } );
    moa["f03"].ma.push( { fid: "f03", name: "Knappar", url: "/gym/prds/btns", fa: "fa fa-bars" } );
    moa["f03"].ma.push( { fid: "f03", name: "Tillval", url: "/gym/prds/addons", fa: "fa fa-bars" } );
    moa["f03"].ma.push( { fid: "f03", name: "Villkor", url: "/gym/prds/cond", fa: "fa fa-bars" } );

    moa["f04"].ma.push( { fid: "f04", name: "Rapporter", url: "/gym/man/rps", fa: "fa fa-bars" } );
    moa["f04"].ma.push( { fid: "f04", name: "Kassa", url: "/gym/man/kassa", fa: "fa fa-bars" } );
    moa["f04"].ma.push( { fid: "f04", name: "Listor", url: "/gym/man/list", fa: "fa fa-bars" } );
    moa["f04"].ma.push( { fid: "f04", name: "Transaktioner", url: "/gym/man/trs", fa: "fa fa-bars" } );
    moa["f04"].ma.push( { fid: "f04", name: "Kvitton", url: "/gym/man/kvitton", fa: "fa fa-bars" } );

    moa["f07"].ma.push( { fid: "f07", name: "Register", url: "/gym/reg", fa: "fa fa-bars" } );
    moa["f07"].ma.push( { fid: "f07", name: "Redovisning", url: "/pos/red", fa: "fa fa-bars" } );
    moa["f07"].ma.push( { fid: "f07", name: "Teknik", url: "/gym/tech", fa: "fa fa-bars" } );

    var aa = [];
    var keys = Object.keys(moa);
    for(var key of keys) {
        var o = moa[key];
        aa.push( o );
    }

    //document.removeEventListener("mousedown", this.handleClick);
    document.addEventListener("mousedown", handleClick);

    var ma = [];
    var mnuHeight = window.innerHeight - 100;

   function handleClick(e) {
    if (e.pageX > 320) {
        if (state.ma.length) {
            setState({mnu : state.mnu, row : state.row, ma : [] });
            return;
        }
    }
  }
   function fknGo(row) {
    //var sdo = useContext(SDO);
    //alert(fkn);
    var fkn = row.fid;
    setState({ mnu : row.fid, row : row,  ma : [] });
    ctx.fid = fkn;

       sso.seo.sfkn = row;
    //props.store.fkn = row;
       navigate(row.url);
   };
   function fknFix(fkn) {
    //var sdo = useContext(SDO);
    //alert(fkn);
    ctx.fid = fkn;

    if(fkn == "lock") navigate('/web');
    if(fkn == "logout") navigate('/');
   };
   function mnuGo(row) {
    //var sdo = useContext(SDO);
    //alert(fkn);
    //ctx.fid = fkn;
    setState({ mnu : state.hfid, row : state.row,  ma : [] });

       sso.seo.sfkn = row;
    //props.store.fkn = row;
       navigate(row.url);
   };
   function hideMnu() {
    setState({mnu : state.mnu, row : state.row, ma : [] });
   };
   function mouseEnter(it) {
    setState({mnu : state.mnu, row : state.row, hfid : it.fid, htitle : it.name, ma : it.ma });
   };
   function mouseLeave() {
    setState({mnu : state.mnu, row : state.row, ma : [] });
   };

   function row_css(row) {
  	    var css = {};
        css.margin = "0px";
        css.padding = "0px";
        css.height = "55px";
        css.borderBottom = "1px #ccc solid";

        if(props.store.fkn && (props.store.fkn != undefined))
        {
            if (props.store.fkn.fid == row.fid) {
               css.background = "#080";
               css.color = "#fff";
            }
        }
		return css;
    }
   function row_icon_css(row) {
  	    var css = {};
        css.paddingTop = "10px";
        css.fontSize = "20px";

        if(props.store.fkn && (props.store.fkn != undefined))
        {
            if (props.store.fkn.fid == row.fid) {
               //css.background = "#080";
               css.color = "#fff";
            }
        }
		return css;
    }

   //<Icon className={ it.fa } style={{ fontSize: 18 }} />
   var html =
        <div className="">
        <div className="cdi_xmnu flex-fullcol" style={{padding: "5px 0px"}}>
            { aa.map((it, key) =>
            <div key={ key } onClick={() => fknGo(it)} className="web-col flex-cc xmnu_tab" style={ row_css(it) } onMouseEnter={ () => mouseEnter(it) }>
                <FontAwesomeIcon icon={ it.icon } size="1x" className="" style={ row_icon_css(it) } />
                <div style={{fontSize: "10px"}}>{ it.name }</div>
            </div>
            )}
            <div onClick={ () => fknFix("lock") } className="web-col flex-cc xmnu_tab">
                <FontAwesomeIcon icon="lock" size="1x" className="" style={{paddingTop: "10px", fontSize: "20px"}} />
                <div style={{fontSize: "10px"}}>Lås</div>
            </div>
            <div onClick={() => fknFix("logout") } className="web-col flex-cc xmnu_tab" >
                <i className="fa fa-power-off flex" aria-hidden="true" style={{paddingTop: "10px", fontSize: "20px"}}></i>
                <div style={{fontSize: "10px"}}>Logga ur</div>
            </div>
        </div>

            { state.ma.length ?
        <div className="mtrl_mnu_sub mtrl_mnu_bg" aria-label="Sub Menu" style={{height: mnuHeight}} onMouseLeave={mouseLeave}>
          <div className="mtrl_mnu_title" onClick={() => hideMnu()}>
            { state.htitle }
          </div>
            { state.ma.map((mi, key) =>
          <div key={key} className="mtrl_mnu_item flex-row" onClick={ () => mnuGo(mi) }>
            <div className="flex">{ mi.name }</div>
            <i className={ mi.fa } aria-hidden="true" style={ row_icon_css(mi) }></i>
          </div>
            )}
        </div>
                : null }
        </div>
    ;
    return html;
}

export default observer(Gym_Menu);
